'use strict'

/**
 * Constants file with the endpoints used by users module to call a REST-services of the backend API.
 *
 * @type {number}
 *
 * @author Valentin Agudelo Aquite
 * @since 20/02/2020 01:01 PM
 * @version 1.0.0
 */

/* Backend endpoints */
const ROOT_URI = `${process.env.VUE_APP_API_URL}`

export const TRAER_TIPOS_DOCUMENTOS = `${ROOT_URI}tipos-documento/`
export const TRAER_OBRAS = `${ROOT_URI}obras/`
export const TRAER_TIPO_MONEDA = `${ROOT_URI}tipos-moneda/`
export const FILTRAR_REFERENCIAS = `${ROOT_URI}pagos/`
export const FILTRAR_IDENTIFICACION = `${ROOT_URI}pagos/`
